module.exports = __webpack_public_path__ + "static/media/card3.830d04bc.jpg";